export const REFETCH_ACCOUNTS = `
  query RefetchAccounts {
    updateAccountsWithOrganizationsInfo {
      new {
        accountId
        accountName
        id
        masterRefId
      }
      updated {
        accountId
        accountName
        id
        masterRefId
      }
    }
  }
`
